import "./About.css"
import { GitHub, Email, LinkedIn } from '@mui/icons-material';


const githubLink = process.env.REACT_APP_GITHUB_LINK;
const linkedInLink = process.env.REACT_APP_LINKEDIN_LINK;

export default function About(props) {

  return (
    <div
      // style={{
      //   textAlign:"center"
      // }}
      className="about-content"
    >
      {/* <h2>About Nic</h2> */}

      <div>
        <div
          className="about-header"
        >
          <h2 className="blue-text">
            Hello! My name is Nic!
          </h2>

          <p>
            I'm a Software Engineer, Musician, and Teacher from Minneapolis, Minnesota.
          </p>
        </div>

        <div>
          <h4 className="blue-text">
            Background
          </h4>
          <p>
            I graduated from the University of Wisconsin with a degree in Music Performance on Guitar. After about a decade of performing and teaching music professionally, I discovered a passion for coding during the COVID-19 lockdown and transitioned into software engineering soon after.
          </p>

          <p>
            I spent four years at Xorfox LLC as a full-stack web developer, working on healthcare related SAAS projects. I helped build a medical insurance review system, a custom dashboarding system for a client's beta product, and several small contracts.
          </p>

          <p>
            Currently, I'm working as a tech lead/senior software engineer at <a target="_blank" rel="noreferrer" href="https://www.goeverblue.com/">Everblue</a>, leading the team working on implementing the EverServe workflow platform for the HOMES & HEAR programs across the country.
          </p>
        </div>

        <div>
          <h4 className="blue-text">
            Interests
          </h4>
          <p>
            I enjoy Pokemon VGC, gardening, cooking, football (Go Pack Go!), and am an active member of my local music & art community. I live in Minneapolis with my wife and three cats, and still occasionally perform and record with bands.
          </p>

          <div
            className="icon-container"
          >
            <a
              target="_blank"
              rel="noreferrer"
              href="/contact"
            >
              <Email className='sp-header-icon' />
            </a>
    
            <a
              target="_blank"
              rel="noreferrer"
              href={githubLink}
            >
              <GitHub className='sp-header-icon' />
            </a>
    
            <a
              target="_blank"
              rel="noreferrer"
              href={linkedInLink}
            >
              <LinkedIn className='sp-header-icon' />
            </a>
          </div>

        </div>
      </div>
    </div>
  )
}